<template>
  <div>
    <label class="d-block">
      {{ $t(config.label) }}
    </label>
    <validation-provider
      :name="$t(`commands.data_types.${config.field_name}`)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        v-model="model"
        :options="options"
        :loading="loading"
        :clearable="true"
        :reduce="(item) => item.value"
        :multiple="multiple || multiple === 1"
        :calculate-position="calculatePosition"
        :append-to-body="appendToBody"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        @input="$emit('input', model)"
      />
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import store from "@/store";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: [Array, Object, Number, String],
    multiple: Boolean | Number,
    config: Object,
    calculatePosition: Function,
    appendToBody: Boolean,
  },
  data() {
    return {
      model: null,
      loading: false,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    options() {
      return store.getters["alarm_comment/getItems"].map((item) => ({
        value: item.comment,
        label: item.comment,
      }));
    },
  },
  watch: {
    value(next) {
      this.model = next;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      await store.dispatch("alarm_comment/getAll");
    } finally {
      this.loading = false;
    }
  },
};
</script>
